import { camelizeKeys } from 'humps';
import { postAsJson } from '@namespace/helpers';

export const selectBonusSystemBonus = ({ bonusId }) =>
  postAsJson(`/service/prewager/campaigns/select`, { bonusId }).then(
    camelizeKeys
  );
